module.exports = __webpack_public_path__ + "img/bg3.a2f87257.jpg";